import type { GetApiB2bPackagesResponse } from '/api';
import type { RootState } from '/business/shared/state/store';

const EMPTY_ARRAY = [] as GetApiB2bPackagesResponse;

export default (state: RootState) => (state.applications?.packages || EMPTY_ARRAY) as GetApiB2bPackagesResponse;
